var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11C0 4.93613 4.9344 0 10.9958 0C17.0571 0 21.9915 4.93613 21.9915 11C21.9915 17.0635 17.0569 22 10.9958 22C10.0518 22 9.52324 21.901 8.55477 21.6041L7.80325 21.3805C6.88418 21.1259 6.14935 21.0139 5.15593 21.015C3.84895 21.0164 3.02922 21.1839 1.67739 21.6096L1.03877 21.8016C0.788947 21.8704 0.575799 21.9185 0.367815 21.9502L0.181796 21.9751L1.62411 16.8123L1.22723 16.0438L1.01736 15.6147C0.349527 14.1703 0 12.5897 0 11ZM5.81663 7.33346C5.48675 7.32722 5.17991 7.55878 5.01361 7.93946C4.84731 8.32014 4.84731 8.79097 5.01361 9.17165C5.17991 9.55233 5.48675 9.78389 5.81663 9.77766H16.1834C16.5133 9.78389 16.8201 9.55233 16.9864 9.17165C17.1527 8.79097 17.1527 8.32014 16.9864 7.93946C16.8201 7.55878 16.5133 7.32722 16.1834 7.33346H5.81663ZM5.81613 12.2223C5.48643 12.2161 5.17976 12.4477 5.01355 12.8284C4.84734 13.209 4.84734 13.6799 5.01355 14.0605C5.17976 14.4412 5.48643 14.6728 5.81613 14.6665H13.7394C14.0691 14.6728 14.3758 14.4412 14.542 14.0605C14.7082 13.6799 14.7082 13.209 14.542 12.8284C14.3758 12.4477 14.0691 12.2161 13.7394 12.2223H5.81613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagse);
export default __webpack_public_path__ + "static/media/messagse.5945562abd72a5318fdaa11d21dc8a13.svg";
export { ForwardRef as ReactComponent };